import { createFileRoute } from "@tanstack/react-router";

import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { RouteGuard } from "@/components/auth/route-guard";
import { AppHeader } from "@/features/dashboard/components/header";
import { AppSidebar } from "@/features/dashboard/components/sidebar";
import OnboardingWizardPage from "@/features/onboarding/pages/onboarding-wizard";
import { AuthProvider } from "@/providers/auth.provider";
import { WorkspaceAppearanceProvider } from "@/providers/workspace-appearance.provider";

// ponytail: AppSidebar/AppHeader call useWorkspaceAppearance - this route must supply the
// provider exactly like the dashboard layout, or the wizard crashes (the provider also puts
// the light-theme class on <body>).
function OnboardingShell() {
  return (
    <div className="console-shell w-full" role="application" aria-label="Onboarding layout">
      <RouteGuard onboardingMode>
        <AppSidebar />
        <SidebarInset>
          <AppHeader />
          <main
            className="flex w-full flex-col gap-4 px-4 pb-8 pt-3 sm:px-6 lg:px-8"
            role="main"
            aria-label="Onboarding content"
          >
            <OnboardingWizardPage />
          </main>
        </SidebarInset>
      </RouteGuard>
    </div>
  );
}

function OnboardingLayout() {
  return (
    <AuthProvider>
      <WorkspaceAppearanceProvider className="contents">
        <SidebarProvider>
          <OnboardingShell />
        </SidebarProvider>
      </WorkspaceAppearanceProvider>
    </AuthProvider>
  );
}

export const Route = createFileRoute("/(app)/onboarding")({
  component: OnboardingLayout,
});
